<template>
  <b-card
    class="profile-header mb-2"
    img-top
    alt="cover photo"
    body-class="p-0"
  >
  <!-- {{ addRequest|| ngoInfo.current_stage<3}} -->
    <b-button variant="success" :disabled="ngoInfo && ngoInfo.current_stage != 3 && chechNumberFounder" size="lg" class="advanced-report" @click="onClickAddRequest" 
      v-if="ngoInfo && ngoInfo.current_stage == 3">
      <span v-if="addRequest">
        <b-spinner class="mx-50" small />
        جاري تقديم طلب التأسيس ...
      </span>
      <span v-else>
        <feather-icon size="20" icon="PlusIcon" />
        تقديم طلب التأسيس
      </span>
       
    </b-button>
    <b-button variant="danger" :disabled="addRequest" size="lg" class="advanced-report" @click="onClickEditRequest"
    v-if="ngoInfo && ngoInfo.current_stage == 6">
      <span v-if="addRequest">
        <b-spinner class="mx-50" small />
        جاري استدراك المعلومات ...
      </span>
      <span v-else>
        <feather-icon size="20" icon="PlusIcon" />
          استدراك معلومات طلب التأسيس
      </span>
       
    </b-button>
    <!-- profile picture -->
    <b-row class="position-relative justify-content-between">
      <b-col lg="5" class="profile-img-container d-flex align-items-center">
        <div class="profile-img" style="position: relative">
          <!-- <div
            style="
             camera
            "
            class="camera-overlay"
            @click="$refs.imageInput.click()"
          >
            <feather-icon
              color="#EEEEEE"
              icon="CameraIcon"
              size="35"
              class="camera-icon"
              style="z-index: 2"
            />
          </div> -->

          <b-img
            style="height: 100%; width: 100%"
            :src="require('@/assets/images/logo/logo_d.jpg')"
            rounded
            fluid
            alt="profile photo"
          />
          <input
            accept="image/*"
            type="file"
            name="image-ngo"
            style="display: none"
            ref="imageInput"
            @change="imageUploaded"
          />
        </div>
        <!-- profile title -->
        <div class="profile-title ml-3">
          <h2 class="text-dark">
            {{ headerData ? headerData.ngo_name : 'لم يتم تحديد اسم للمنظمة' }}
          </h2>
          <span class="align-middle">
            الشكل القانوني :
            {{ headerData ? $t(headerData.legal_form_type) : 'لم يتم تحديد الشكل القانوني' }}</span
          >
          <p v-if="ngoInfo">
            <small v-if="ngoInfo.current_stage == 4" class="text-success">
              تم تقديم طلب التأسيس
            </small>
            <small v-else-if="ngoInfo.current_stage == 6" class="text-danger">
             طُلبَ استدراك بيانات طلب التأسيس
            </small>

          </p>

          
          <!-- <small v-if="headerData">
            {{
              headerData.status === "docs_evaluating"
                ? "يتم تدقيق الوثائق"
                : headerData.status === "info_evaluating"
                ? "يتم تدقيق البيانات"
                : "تمت الموافقة على الطلب"
            }}
          </small> -->
        </div>
        <!--/ profile title -->
      </b-col>
    </b-row>
    <!--/ profile picture -->

    <!-- profile navbar -->
    <div class="profile-header-nav">
      <b-navbar toggleable="md" type="light">
        <!-- toggle button -->
        <b-navbar-toggle class="ml-1" target="nav-text-collapse">
          <feather-icon icon="AlignJustifyIcon" size="21" />
        </b-navbar-toggle>
        <!--/ toggle button -->

        <!-- collapse -->
        <b-collapse id="nav-text-collapse" is-nav>
          <b-tabs pills class="profile-tabs mt-1 mt-md-0" nav-class="mb-0">
            <template #tabs-start>
              <b-nav-item
                v-for="(tab, index) in profileTabs"
                :key="index"
                class="font-weight-bold"
                :active="$route.path === tab.path"
                @click="navigate(tab, index)"
              >
                <feather-icon :icon="tab.icon" class="d-block align-middle" />

                <span
                  v-if="tab.label"
                  style="user-select: none; cursor: pointer; margin: 0px 8px"
                  class="d-none d-md-block"
                  >{{ tab.label }}
                </span>
              </b-nav-item>
            </template>
          </b-tabs>
        </b-collapse>
        <!--/ collapse -->
      </b-navbar>
    </div>
    <!--/ profile navbar -->
  </b-card>
</template>

<script>
import {
  BCard,
  BImg,
  BNavbar,
  BNavbarToggle,
  BCollapse,
  BTabs,
  BTab,
  BNavItem,
  BButton,
  BRow,
  BCol,
  BSpinner
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapGetters , mapActions } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    BCard,
    BTabs,
    BTab,
    BButton,
    BRow,
    BCol,
    BNavItem,
    BNavbar,
    BNavbarToggle,
    BCollapse,
    BImg,
    BSpinner
  },
  directives: {
    Ripple,
  },
  props: {
    headerData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeTab: 0,
      logo: null,
      profileTabs: [
        {
          label: "معلومات الحساب",
          path: "/temp-ngo/temp-account-info",
          icon: "UserIcon",
        },
        {
          label: "معلومات المنظمة",
          path: "/temp-ngo/temp-ngo-info",
          icon: "InfoIcon",
        },

        {
          label: "الأعضاء المؤسسين و مؤهلاتهم",
          path: "/temp-ngo/temp-founders-info",
          icon: "UsersIcon",
        },
        {
          label: "وثائق التأسيس",
          path: "/temp-ngo/docs-upload",
          icon: "FileTextIcon",
        },
        {
          label: "سير المعاملة",
          path: "/temp-ngo/ministry-track",
          icon: "SendIcon",
        },
      ],
    };
  },
  watch: {
    activeTab(val) {
      this.$emit("tabChange", val);
    },
  },
  computed: {
    ...mapGetters("TempNgo", ["addRequest" , "ngoInfo" , "founders" , "transaction"]),
    ...mapGetters("TempNgo/Track", ["transaction"]),
    ngoLogo() {
      return this.logo || this.headerData.logo;
    },
  },
  mounted() {
    if (this.ngoInfo && this.ngoInfo.current_stage >=4){
      this.fetchTransaction()
    }
  },
  methods: {
    ...mapActions("TempNgo", ["AddTransactionRequests", "changeCurrentStage" , "fetchNgoData" , "editTransactionRequests"]),
    ...mapActions("TempNgo/Track", ["fetchTransaction"]),
    imageUploaded(e) {
      this.logo = URL.createObjectURL(e.target.files[0]);
    },
    navigate(tab, index) {
      this.activeTab = index;
      this.$router.push(tab.path);
    },
    chechNumberFounder(){
      if(this.founders.length % 2 === 0){
        return false
      }else{
        return true
      }
    },
    onClickAddRequest(){
      this.AddTransactionRequests({est_ngo_id: this.headerData.id , slug :'establishing_ngo'})
          
      .then(async (value) => {
        this.$toast({
            component: ToastificationContent,
            props: {
              title: "تم تقديم الطلب بنجاح",
              icon: "CheckSquareIcon",
              variant: "success",
              timeout: 6000,
            },
          });
          this.changeCurrentStage(4)
          
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title:"حدث خطأ أثناء تقديم الطلب",
              icon: "AlertCircleIcon",
              variant: "danger",
              timeout: 6000,
            },
          });
        });
      
    },
    
    onClickEditRequest(){
      console.log("ngoInfo" , this.ngoInfo.legal_form_type)
      // let numberOfFounder 
      // if(this.ngoInfo.legal_form_type === 'association'){
      //   numberOfFounder = 11
      // }
      // else  if(this.ngoInfo.legal_form_type === 'institution'){
      //   numberOfFounder = 1
      // }
      // else{
      //   numberOfFounder = 7
      // }
      // let message = `يجب أن يكون عدد الأعضاء المؤسسين على الأقل ${numberOfFounder} عضو`
      // if(this.founders.length === numberOfFounder){
      //   this.editTransactionRequests({'id':1})
      // }
      // else{
      //   this.$toast({
      //   component: ToastificationContent,
      //   props: {
      //     title: message,
      //     icon: "AlertCircleIcon",
      //     variant: "danger",
      //     },
      //   });

      // }
      // console.log("founders" , this.founders.length)
      this.editTransactionRequests({'id':this.transaction.id})
      .then(() => {
        this.$toast({
            component: ToastificationContent,
            props: {
              title: "تم استدراك الطلب بنجاح",
              icon: "CheckSquareIcon",
              variant: "success",
              timeout: 6000,
            },
          });
          this.changeCurrentStage(4)
          this.fetchNgoData()
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title:"حدث خطأ أثناء استدراك الطلب",
              icon: "AlertCircleIcon",
              variant: "danger",
              timeout: 6000,
            },
          });
        });
      
    }
  },
};
</script>

<style lang="scss">
.advanced-report {
  position: fixed;
  top: 13%;
  z-index: 1031;
  right: 1%;
}
.camera-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0;
  transition: all 0.3s ease;
  cursor: pointer;
  user-select: none;
  &:active {
    background-color: gray;
  }
  &:hover {
    opacity: 0.8;
  }
  z-index: 1;
}
.camera-icon {
  position: absolute;
  left: 35%;
  top: 35%;
}
.nav-link.active {
  transition: all 0.2s ease-in-out;
}
.nav-link {
  &:hover {
    opacity: 0.7;
    transition: all 0.2s ease-in-out;
  }
}
</style>
